<template>
  <v-list-item
    class="white rounded-lg"
    three-line
    :to="`/visita-tecnica/${visita.id}`"
  >
    <div class="date-stack mr-2">
      <v-sheet
        class="date-badge"
        width="50"
        height="50"
        elevation="0"
        :class="badgeBgClass"
      >
        <span :class="['date-day', badgeTextClass]">
          {{ visita.dia_visita }}
        </span>
        <span :class="['date-month', badgeTextClass]">
          {{ visita.mes_visita }}
        </span>
      </v-sheet>
    </div>

    <v-divider vertical class="mx-2"></v-divider>

    <v-list-item-content>
      <v-list-item-title>
        <span class="font-weight-bold">{{ visita.nome_produtor }}</span>
        <small class="ml-1 font-weight-medium">({{ visita.matricula }})</small>
      </v-list-item-title>

      <v-list-item-subtitle>
        {{ visita.cidade }} - {{ visita.uf }} · ID #{{ visita.id }}
      </v-list-item-subtitle>

      <v-list-item-subtitle>
        <chip-status-visita :visita="visita" :xsmall="true" />
        <!-- registro só local -->
        <v-chip
          v-if="visita.criado_offline"
          x-small
          label
          color="warning"
          class="ml-2"
        >
          <v-icon left x-small>mdi-cloud-off-outline</v-icon>
          Local
        </v-chip>
        <v-chip outlined x-small label  class="ml-1" color="warning" v-else-if="visita.atualizar"
          ><v-icon color="orange" x-small left> mdi-pencil </v-icon
          >Editado offline</v-chip>
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <btn-remover-visita v-if="visita.permite_deletar" :visita="visita" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import BtnRemoverVisita from "./BtnRemoverVisita.vue";
import ChipStatusVisita from "./ChipStatusVisita.vue";

export default {
  name: "VisitaTile",
  components: { BtnRemoverVisita, ChipStatusVisita },
  computed: {
    // fundo claro quando tema claro; fundo escuro quando tema dark
    badgeBgClass() {
      // no mobile dark fullscreen, um fundo claro “estoura”, então invertemos:
      return this.$vuetify.theme.dark ? "grey darken-3" : "primary lighten-5";
    },
    // texto branco no dark; texto na cor primária no light
    badgeTextClass() {
      return this.$vuetify.theme.dark ? "white--text" : "primary--text";
    },
  },
  props: {
    visita: { type: Object, required: true },
  },
};
</script>

<style scoped>
.date-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.date-badge {
  border-radius: 12px; /* combina com seus cards arredondados */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1;
  /* sem border/hex: quem dá cor é a classe do Vuetify (badgeBgClass) */
}

.date-day {
  font-weight: 800;
  font-size: 0.95rem;
}
.date-month {
  margin-top: -2px;
  font-weight: 600;
  font-size: 0.68rem;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

/* opcional se habilitar o id abaixo
.date-id {
  margin-top: 4px; font-size: .72rem; font-weight: 600; color: #6b7280;
}
*/
</style>
